import { useEffect } from "react";

import { useHistory, useLocation } from "react-router-dom";

export interface PageNotificationState {
    notification?: string;
}

/*
* Сообщение, которое показывается уже на другой странице. Нужно, когда результат действия виден
* не там, где действие произошло: сохранение и удаление позиции меню уводят на экран меню, и
* уведомление должно доехать вместе с переходом.
*
* Едет оно состоянием роута (`history.push(path, notifyOnPage(...))`), а не глобальной
* переменной: состояние умирает вместе с записью в истории, поэтому «висящих» сообщений не
* бывает и хранить их между экранами негде.
* */
export const notifyOnPage = (message: string): PageNotificationState => ({
    notification: message,
});

export const usePageNotification = (showSuccess: (title: string) => void) => {
    const history = useHistory();
    const location = useLocation<PageNotificationState | undefined>();

    const message = location.state ? location.state.notification : undefined;

    useEffect(() => {
        if (!message) return;

        showSuccess(message);

        /*
        * Состояние вычищаем сразу: без этого сообщение всплывает заново на «назад» в браузере
        * и на любой перерисовке, восстанавливающей ту же запись истории.
        * */
        history.replace(location.pathname + location.search);
    }, [history, location.pathname, location.search, message, showSuccess]);
};
